import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getChannel, getChannelHistory, getUserCreatedChannel } from "../../api/channels/channelServices";

import { SKContentStatusHistory } from "../../models/SKArtifact";
import { format } from "date-fns";
import { SKChannelStatusHistory } from "../../models/SKChannel";
import { capitalizeFirstLetter } from "../../utils/stringFunctions";
import { ModeratorChannelContext } from "../../context/ModerationChannelContext";
import { useNavigationBar } from "../../context/NavigationContext";

const ChannelHistory = () => {
  const location = useLocation();
  const { id } = useParams();
  const [statusList, setStatusList] = useState<SKChannelStatusHistory[]>([]);
  const { channelData } = useContext(ModeratorChannelContext);
  const { setNavProps } = useNavigationBar();
  const navigate = useNavigate();
  useEffect(() => {
    const getHistory = async (id: string) => {
      const statusList = await getChannelHistory(id);
      setStatusList(statusList);
    };
    if (id) {
      getHistory(id);
    }
  }, [id]);

  useEffect(() => {
    channelData?.id &&
      setNavProps({
        backArrow: false,
        title: "Status History",
        subtitle: channelData.name || "",
        buttonTitle: "",
        enableLink: true,
        onClose: () => {
          navigate(-1);
        },
      });
  }, [channelData, setNavProps]);

  return (
    <div className="flex flex-col gap-[10px] mt-[15px]">
      {statusList.map((item, index) => {
        return (
          <div key={index} className="relative w-full">
            <div className="flex flex-col w-full">
              <div>
                <p className="history-date">{item.createdDate ? format(item.createdDate.toDate(), "MMM, dd yyyy hh:mm a") : "--"}</p>
              </div>
              <div>
                <p className="history-status">{capitalizeFirstLetter(item.status)}</p>
              </div>
              {item.status && (
                <div>
                  <p className="history-note-reasoncode">{item.reason}</p>
                </div>
              )}

              {item.note && (
                <div>
                  <p className="history-note-reasoncode">{item.note}</p>
                </div>
              )}
            </div>
            <div className="thinseparator mt-[10px]" />
          </div>
        );
      })}
    </div>
  );
};

export default ChannelHistory;
